var _circle, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6804,
    cy: 14.7542,
    r: 14.3484,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3282 15.3854C21.3282 14.8603 21.281 14.3553 21.1935 13.8706H14.2188V16.7352H18.2043C18.0327 17.6609 17.5109 18.4453 16.7266 18.9704V20.8285H19.1199C20.5203 19.5393 21.3282 17.6408 21.3282 15.3854Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2195 22.6226C16.219 22.6226 17.8954 21.9595 19.1207 20.8284L16.7273 18.9703C16.0642 19.4146 15.2159 19.6772 14.2195 19.6772C12.2907 19.6772 10.6581 18.3744 10.0757 16.624H7.60156V18.5428C8.82013 20.9631 11.3246 22.6226 14.2195 22.6226Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0743 16.624C9.92624 16.1797 9.84208 15.705 9.84208 15.2169C9.84208 14.7288 9.92624 14.2542 10.0743 13.8098V11.8911H7.60019C7.09863 12.8909 6.8125 14.0219 6.8125 15.2169C6.8125 16.4119 7.09863 17.543 7.60019 18.5427L10.0743 16.624Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2195 10.757C15.3068 10.757 16.283 11.1306 17.0505 11.8644L19.1746 9.74036C17.892 8.54536 16.2157 7.81152 14.2195 7.81152C11.3246 7.81152 8.82013 9.47106 7.60156 11.8914L10.0757 13.8101C10.6581 12.0597 12.2907 10.757 14.2195 10.757Z",
    fill: "#EA4335"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.29121823659ffbb49bb5b16d93364cb7.svg";
export { ForwardRef as ReactComponent };